import { render, staticRenderFns } from "./myComment.vue?vue&type=template&id=18cb9ba3&scoped=true"
import script from "./myComment.vue?vue&type=script&lang=js"
export * from "./myComment.vue?vue&type=script&lang=js"
import style0 from "./myComment.vue?vue&type=style&index=0&id=18cb9ba3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cb9ba3",
  null
  
)

export default component.exports